import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  key: 0
};
import { RecordVideoService } from '@/services/recordVideo/recordVideo.service';
import { useService } from '@kaokei/use-vue-service';
import deviceCheck from './components/deviceCheck/index.vue';
import RecordModule from './components/recordModule/index.vue';
import VideoPreview from './components/videoPreview/index.vue';
import UploadVideo from './components/uploadVideo/index.vue';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var recordVideoService = useService(RecordVideoService);
    recordVideoService.init();
    return function (_ctx, _cache) {
      return _unref(recordVideoService).showRecordScreenCom ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_unref(recordVideoService).showDeviceCheck ? (_openBlock(), _createBlock(deviceCheck, {
        key: 0
      })) : _createCommentVNode("", true), _unref(recordVideoService).showRecordModule ? (_openBlock(), _createBlock(RecordModule, {
        key: 1
      })) : _createCommentVNode("", true), _createVNode(VideoPreview), _createVNode(UploadVideo)])) : _createCommentVNode("", true);
    };
  }
});